import React from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const TeamSection = () => {

  const teamMembers = [
    {
      id: 1,
      name: "Mirco Lehr",
      email: "info@advocall.de",
      position: "Geschäftsführender Partner",
      specialization: "",
      experience: null,
      certifications: [],
      image: "/assets/images/ML-Portrat-neu-1788637393994.jpeg",
    },
    {
      id: 3,
      name: "Vincent Fink",
      email: "vincent.fink@advocall.de",
      position: "Referent der Geschäftsleitung · Client Relations",
      specialization: "",
      experience: null,
      certifications: [],
      image: "/assets/images/vincent_fink-1788637462977.png",
    },
    {
      id: 2,
      name: "Annika Kreusch",
      email: "annika.kreusch@advocall.de",
      position: "Director of Strategic Partnerships",
      specialization: "",
      experience: null,
      certifications: [],
      image: "/assets/images/Photo_AK_2-1776157175700.jpg",
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-text-primary mb-4">
            Unser Expertenteam
          </h2>
          <p className="text-lg text-text-secondary max-w-3xl mx-auto">
            Hochqualifizierte Rechtsanwälte mit langjähriger Erfahrung und Spezialisierung 
            in verschiedenen Rechtsgebieten stehen Ihnen zur Verfügung.
          </p>
          <div className="mt-16">
            <h3 className="text-3xl lg:text-4xl font-bold text-text-primary mb-3">
              Ihre Ansprechpartner
            </h3>
            <p className="text-lg text-text-secondary max-w-3xl mx-auto">
              Für Fragen rund um Advocall stehen Ihnen die folgenden Ansprechpartner gerne zur Verfügung.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-8 items-stretch max-w-5xl mx-auto">
          {teamMembers?.map((member, index) => (
            <motion.div
              key={member?.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="relative h-full"
            >
              <div className="bg-white rounded-xl shadow-professional border border-slate-200 overflow-hidden h-full">
                {/* Profile Image */}
                <div className="relative h-64 overflow-hidden">
                  <Image
                    src={member?.image}
                    alt={member?.name}
                    className={`w-full h-full object-cover ${member?.id === 1 ? 'object-[center_15%]' : 'object-top'}`}
                  />
                </div>

                {/* Basic Info */}
                <div className="p-6">
                  <h3 className="text-xl font-semibold text-text-primary mb-1">
                    {member?.name}
                  </h3>
                  <a
                    href={`mailto:${member?.email}`}
                    className="text-sm text-primary hover:underline block mb-2"
                  >
                    {member?.email}
                  </a>
                  <p className="text-primary font-medium mb-2">
                    {member?.position}
                  </p>
                  
                  <div className="flex items-center space-x-4 text-sm text-text-secondary">
                    {member?.experience && (
                      <div className="flex items-center space-x-1">
                        <Icon name="Clock" size={16} />
                        <span>{member?.experience}</span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Team Stats */}
        <div className="mt-16 bg-gradient-to-r from-primary to-accent rounded-2xl p-8 text-white">
          <div className="grid md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="text-3xl font-bold mb-2">8</div>
              <div className="text-white/80">Jahre Durchschnittserfahrung</div>
            </div>
            <div>
              <div className="text-3xl font-bold mb-2">5</div>
              <div className="text-white/80">Sprachen verfügbar</div>
            </div>
            <div>
              <div className="text-3xl font-bold mb-2">24/7</div>
              <div className="text-white/80">Notfallberatung</div>
            </div>
            <div>
              <div className="text-3xl font-bold mb-2">&lt; 2 Min</div>
              <div className="text-white/80">Wartezeit</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TeamSection;